const ANONYMOUS_ID_KEY = 'bb_signup_anonymous_id'
const SESSION_ID_KEY = 'bb_signup_session_id'

function mintId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `bb-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

export function getAnonymousId(): string {
  try {
    if (typeof window === 'undefined') {
      return mintId()
    }
    const existing = window.localStorage.getItem(ANONYMOUS_ID_KEY)
    if (existing && existing.length > 0) {
      return existing
    }
    const minted = mintId()
    window.localStorage.setItem(ANONYMOUS_ID_KEY, minted)
    return minted
  } catch {
    return mintId()
  }
}

export function getSessionId(): string {
  try {
    if (typeof window === 'undefined') {
      return mintId()
    }
    const existing = window.sessionStorage.getItem(SESSION_ID_KEY)
    if (existing && existing.length > 0) {
      return existing
    }
    const minted = mintId()
    window.sessionStorage.setItem(SESSION_ID_KEY, minted)
    return minted
  } catch {
    return mintId()
  }
}
